import useTranslation from '../../hooks/useTranslation';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ComingSoonNotice: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const translations = useTranslation();

    return (
        <VerticalContainer className={styles.comingSoonNotice} testId={testId}>
            <Wrapper className={styles.title}>{translations.COMING_SOON_TITLE}</Wrapper>

            <Wrapper className={styles.body}>{translations.COMING_SOON_BODY}</Wrapper>
        </VerticalContainer>
    );
};

export default ComingSoonNotice;
